"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthResource = void 0;
class AuthResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /** Staff sign-in. Stores the returned pair so later calls are authenticated. */
    async login(payload) {
        const session = await this.http.post('auth/login', payload, {
            skipAuth: true,
        });
        await this.http.setTokens(session.tokens);
        return session;
    }
    /**
     * Telegram Mini App sign-in (TZ §48). `initData` is forwarded verbatim — the
     * backend verifies its signature before trusting any field.
     */
    async loginWithTelegram(payload) {
        const session = await this.http.post('auth/telegram', payload, {
            skipAuth: true,
        });
        await this.http.setTokens(session.tokens);
        return session;
    }
    me() {
        return this.http.get('auth/me');
    }
    /**
     * Explicit refresh. Normal calls refresh automatically inside
     * {@link HttpClient}; this exists for apps that warm the session on boot.
     */
    async refresh(refreshToken) {
        const tokens = await this.http.post('auth/refresh', { refreshToken }, { skipAuth: true });
        await this.http.setTokens(tokens);
        return tokens;
    }
    /** Revokes the refresh token server-side, then drops it locally. */
    async logout() {
        try {
            await this.http.post('auth/logout');
        }
        finally {
            // Clear locally even if the network call failed — the user asked to leave.
            await this.http.clearTokens();
        }
    }
    changePassword(payload) {
        return this.http.post('auth/change-password', payload);
    }
}
exports.AuthResource = AuthResource;
//# sourceMappingURL=auth.js.map